import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iheathgene',
  templateUrl: './iheathgene.component.html',
  styleUrls: ['./iheathgene.component.css']
})
export class IheathgeneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
